import { useStairs } from "providers/StairsProvider";
import StairActionFeedback from "./StairActionFeedback";
import StairTypeDialog from "./StairTypeDialog";
import { useScreen } from "layout/ControlLayout";

const Stairs = () => {
    const {
        actionStatus,
        actionResult,
        actionFeedback,
        showActionFeedback,
        setShowActionFeedback,
        isActionValid,
        goalId,
        handleStairConfirm,
        handleActionCancel,
        handleForceClose,
    } = useStairs();

    const { showStairsDialog, setShowStairsDialog } = useScreen();

    const handleFeedbackClose = () => {
        // Close dialog only - do NOT change action state
        // The action continues running in the background
        setShowActionFeedback(false);
    };

    return (
        <>
            <StairTypeDialog
                visible={showStairsDialog}
                onConfirm={handleStairConfirm}
                onClose={() => setShowStairsDialog(false)}
            />
            <StairActionFeedback
                visible={showActionFeedback}
                feedback={actionFeedback}
                result={actionResult}
                status={actionStatus}
                isActionValid={isActionValid}
                goalId={goalId}
                onCancel={handleActionCancel}
                onClose={handleFeedbackClose}
                onForceClose={handleForceClose}
            />
        </>
    );
};

export default Stairs;